import { Fragment } from 'react';

import moment from 'moment';
import { RawIntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import { generateIntl } from '@helpers/intl';
import translations from '@translations';

const mapStateToProps = state => {
  let cultureCode = state.user?.language || localStorage.getItem('language');

  if (!cultureCode) {
    cultureCode = 'en';
  } else if (state.user?.language !== localStorage.getItem('language')) {
    cultureCode = localStorage.getItem('language');
  }

  moment.locale(cultureCode);

  const messages = translations[cultureCode];

  const intl = generateIntl(cultureCode, messages);

  return {
    locale: cultureCode,
    defaultLocale: 'en',
    messages,
    value: intl,
    textComponent: Fragment,
  };
};

export default connect(mapStateToProps)(RawIntlProvider);
